import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import mixpanel from 'mixpanel-browser';

if (environment.production) {
  enableProdMode();
}

if (environment.production && environment.MIXPANEL_TOKEN) {
  mixpanel.init(environment.MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
    record_mask_text_selector: '',
    record_block_selector: ''
  });
}

if (environment.production && environment.SENTRY_DSN) {
  let tracePropagationTargets: (string | RegExp)[];

    tracePropagationTargets = [
      /^https:\/\/([a-zA-Z0-9_-]+\.)*exam\.ly/,
      /^https:\/\/([a-zA-Z0-9_-]+\.)*examly\.net/,
      /^https:\/\/([a-zA-Z0-9_-]+\.)*examly\.io/
    ];

  Sentry.init({
    dsn: environment.SENTRY_DSN,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    tracesSampleRate: 0.5,
    tracePropagationTargets: tracePropagationTargets
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
